import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './context/ProtectedRoute';
import Navigation from './components/Navigation';
import QRScanner from './components/QRScanner';
import Home from './pages/Home';
import Categories from './pages/Categories';
import ScanPage from './pages/ScanPage';
import ReelsView from './pages/ReelsView';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminCategoryManager from './pages/admin/AdminCategoryManager';
import './styles/index.css';

function App() {
  const [showQRScanner, setShowQRScanner] = useState(false);

  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable specific keyboard shortcuts (F12, Ctrl+Shift+I, etc.)
    const handleKeyDown = (e) => {
      // F12
      if (e.keyCode === 123) {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+I (Inspect)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+C (Inspect Element)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
        e.preventDefault();
        return false;
      }
      // Ctrl+U (View Source)
      if (e.ctrlKey && e.keyCode === 85) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleQRScan = (categoryId) => {
    setShowQRScanner(false);
    window.location.href = `/reels/${categoryId}`;
  };

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/category/:categoryId"
            element={
              <ProtectedRoute>
                <AdminCategoryManager />
              </ProtectedRoute>
            }
          />

          {/* Reels View - Full Screen (No Navigation) */}
          <Route path="/reels/:categoryId" element={<ReelsView />} />

          {/* Direct Scan Route */}
          <Route path="/scan" element={<ScanPage />} />

          {/* Public Routes with Navigation */}
          <Route
            path="/*"
            element={
              <>
                <Navigation onQRClick={() => setShowQRScanner(true)} />
                {showQRScanner && (
                  <QRScanner
                    onScan={handleQRScan}
                    onClose={() => setShowQRScanner(false)}
                  />
                )}
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/categories" element={<Categories />} />
                </Routes>
              </>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
